import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Inject } from '@angular/core';
import { map, mapTo, filter, take, switchMap, retry } from 'rxjs/operators';
import * as uuid from 'uuid';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i4 from 'rxjs';
import { throwError, forkJoin } from 'rxjs';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PersonaType = /*#__PURE__*/function (PersonaType) {
  PersonaType[PersonaType["PERSONA_TYPE_UNSET"] = 0] = "PERSONA_TYPE_UNSET";
  PersonaType[PersonaType["PERSONA_TYPE_PARTNER"] = 1] = "PERSONA_TYPE_PARTNER";
  PersonaType[PersonaType["PERSONA_TYPE_SALES_PERSON"] = 2] = "PERSONA_TYPE_SALES_PERSON";
  PersonaType[PersonaType["PERSONA_TYPE_DIGITAL_AGENT"] = 3] = "PERSONA_TYPE_DIGITAL_AGENT";
  PersonaType[PersonaType["PERSONA_TYPE_SMB"] = 4] = "PERSONA_TYPE_SMB";
  return PersonaType;
}(PersonaType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var KeyValueField = /*#__PURE__*/function (KeyValueField) {
  KeyValueField[KeyValueField["KEY_VALUE_FIELD_UNSET"] = 0] = "KEY_VALUE_FIELD_UNSET";
  KeyValueField[KeyValueField["KEY_VALUE_FIELD_DATA"] = 1] = "KEY_VALUE_FIELD_DATA";
  KeyValueField[KeyValueField["KEY_VALUE_FIELD_METADATA"] = 2] = "KEY_VALUE_FIELD_METADATA";
  return KeyValueField;
}(KeyValueField || {});
var Metric = /*#__PURE__*/function (Metric) {
  Metric[Metric["METRIC_NAMESPACE"] = 0] = "METRIC_NAMESPACE";
  Metric[Metric["METRIC_TYPE"] = 1] = "METRIC_TYPE";
  Metric[Metric["METRIC_TAG"] = 2] = "METRIC_TAG";
  Metric[Metric["METRIC_STATUS"] = 3] = "METRIC_STATUS";
  Metric[Metric["METRIC_ASSIGNEE"] = 4] = "METRIC_ASSIGNEE";
  Metric[Metric["METRIC_OLDEST_DUE_DATE"] = 5] = "METRIC_OLDEST_DUE_DATE";
  Metric[Metric["METRIC_STATUS_PER_TYPE"] = 6] = "METRIC_STATUS_PER_TYPE";
  Metric[Metric["METRIC_TYPE_PER_ASSIGNEE"] = 7] = "METRIC_TYPE_PER_ASSIGNEE";
  Metric[Metric["METRIC_STATUS_PER_ASSIGNEE_PER_TYPE"] = 8] = "METRIC_STATUS_PER_ASSIGNEE_PER_TYPE";
  Metric[Metric["METRIC_UNUSED"] = 9] = "METRIC_UNUSED";
  Metric[Metric["METRIC_STATUS_PER_ASSIGNEE"] = 10] = "METRIC_STATUS_PER_ASSIGNEE";
  Metric[Metric["METRIC_PARTNER"] = 11] = "METRIC_PARTNER";
  Metric[Metric["METRIC_PER_DAY"] = 12] = "METRIC_PER_DAY";
  Metric[Metric["METRIC_FULFILLING_PARTNER"] = 13] = "METRIC_FULFILLING_PARTNER";
  Metric[Metric["METRIC_TYPE_PER_DAY"] = 14] = "METRIC_TYPE_PER_DAY";
  Metric[Metric["METRIC_TAG_PER_DAY"] = 15] = "METRIC_TAG_PER_DAY";
  Metric[Metric["METRIC_COUNT_BY_DATE_RANGE"] = 16] = "METRIC_COUNT_BY_DATE_RANGE";
  Metric[Metric["METRIC_TASKS_COMPLETED_BY_DELAY"] = 17] = "METRIC_TASKS_COMPLETED_BY_DELAY";
  Metric[Metric["METRIC_TASKS_OVERDUE_BY_DELAY"] = 18] = "METRIC_TASKS_OVERDUE_BY_DELAY";
  return Metric;
}(Metric || {});
var RangeField = /*#__PURE__*/function (RangeField) {
  RangeField[RangeField["RANGE_FIELD_DUE_DATE"] = 0] = "RANGE_FIELD_DUE_DATE";
  RangeField[RangeField["RANGE_FIELD_COMPLETION_DATE"] = 1] = "RANGE_FIELD_COMPLETION_DATE";
  RangeField[RangeField["RANGE_FIELD_CREATED_DATE"] = 2] = "RANGE_FIELD_CREATED_DATE";
  return RangeField;
}(RangeField || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 0] = "SORT_DIRECTION_DESCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************

function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccessPermissions {
  static fromProto(proto) {
    let m = new AccessPermissions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.read !== 'undefined') {
      toReturn['read'] = this.read;
    }
    if (typeof this.write !== 'undefined') {
      toReturn['write'] = this.write;
    }
    if (typeof this.delete !== 'undefined') {
      toReturn['delete'] = this.delete;
    }
    return toReturn;
  }
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    if (proto.filePermissions) {
      m.filePermissions = AccessPermissions.fromProto(proto.filePermissions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.uploadingPersonaType !== 'undefined') {
      toReturn['uploadingPersonaType'] = this.uploadingPersonaType;
    }
    if (typeof this.filePermissions !== 'undefined' && this.filePermissions !== null) {
      toReturn['filePermissions'] = 'toApiJson' in this.filePermissions ? this.filePermissions.toApiJson() : this.filePermissions;
    }
    return toReturn;
  }
}
class Conversation {
  static fromProto(proto) {
    let m = new Conversation();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.persona) {
      m.persona = enumStringToValue$2(PersonaType, proto.persona);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sendFrom !== 'undefined') {
      toReturn['sendFrom'] = this.sendFrom;
    }
    if (typeof this.sendTo !== 'undefined') {
      toReturn['sendTo'] = this.sendTo;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.persona !== 'undefined') {
      toReturn['persona'] = this.persona;
    }
    return toReturn;
  }
}
class History {
  static fromProto(proto) {
    let m = new History();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.user !== 'undefined') {
      toReturn['user'] = this.user;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class KeyValuesKeyValue {
  static fromProto(proto) {
    let m = new KeyValuesKeyValue();
    m = Object.assign(m, proto);
    if (proto.values) {
      m.values = proto.values.map(KeyValuesKeyValueValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    return toReturn;
  }
}
class KeyValues {
  static fromProto(proto) {
    let m = new KeyValues();
    m = Object.assign(m, proto);
    if (proto.keyValues) {
      m.keyValues = proto.keyValues.map(KeyValuesKeyValue.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyValues !== 'undefined' && this.keyValues !== null) {
      toReturn['keyValues'] = 'toApiJson' in this.keyValues ? this.keyValues.toApiJson() : this.keyValues;
    }
    return toReturn;
  }
}
class Task {
  static fromProto(proto) {
    let m = new Task();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.history) {
      m.history = proto.history.map(History.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.completionDate) {
      m.completionDate = new Date(proto.completionDate);
    }
    if (proto.subtasks) {
      m.subtasks = proto.subtasks.map(TaskIdentity.fromProto);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.conversations) {
      m.conversations = proto.conversations.map(Conversation.fromProto);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.attachment) {
      m.attachment = proto.attachment.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.history !== 'undefined' && this.history !== null) {
      toReturn['history'] = 'toApiJson' in this.history ? this.history.toApiJson() : this.history;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.completionDate !== 'undefined' && this.completionDate !== null) {
      toReturn['completionDate'] = 'toApiJson' in this.completionDate ? this.completionDate.toApiJson() : this.completionDate;
    }
    if (typeof this.subtasks !== 'undefined' && this.subtasks !== null) {
      toReturn['subtasks'] = 'toApiJson' in this.subtasks ? this.subtasks.toApiJson() : this.subtasks;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    return toReturn;
  }
}
class TaskIdentity {
  static fromProto(proto) {
    let m = new TaskIdentity();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPath !== 'undefined') {
      toReturn['parentPath'] = this.parentPath;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    return toReturn;
  }
}
class TaskTree {
  static fromProto(proto) {
    let m = new TaskTree();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.history) {
      m.history = proto.history.map(History.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.completionDate) {
      m.completionDate = new Date(proto.completionDate);
    }
    if (proto.subtasks) {
      m.subtasks = proto.subtasks.map(TaskTree.fromProto);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.conversations) {
      m.conversations = proto.conversations.map(Conversation.fromProto);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.attachment) {
      m.attachment = proto.attachment.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.history !== 'undefined' && this.history !== null) {
      toReturn['history'] = 'toApiJson' in this.history ? this.history.toApiJson() : this.history;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.completionDate !== 'undefined' && this.completionDate !== null) {
      toReturn['completionDate'] = 'toApiJson' in this.completionDate ? this.completionDate.toApiJson() : this.completionDate;
    }
    if (typeof this.subtasks !== 'undefined' && this.subtasks !== null) {
      toReturn['subtasks'] = 'toApiJson' in this.subtasks ? this.subtasks.toApiJson() : this.subtasks;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    return toReturn;
  }
}
class KeyValuesKeyValueValue {
  static fromProto(proto) {
    let m = new KeyValuesKeyValueValue();
    m = Object.assign(m, proto);
    if (proto.int64Value) {
      m.int64Value = parseInt(proto.int64Value, 10);
    }
    if (proto.timeValue) {
      m.timeValue = new Date(proto.timeValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stringValue !== 'undefined') {
      toReturn['stringValue'] = this.stringValue;
    }
    if (typeof this.int64Value !== 'undefined') {
      toReturn['int64Value'] = this.int64Value;
    }
    if (typeof this.boolValue !== 'undefined') {
      toReturn['boolValue'] = this.boolValue;
    }
    if (typeof this.doubleValue !== 'undefined') {
      toReturn['doubleValue'] = this.doubleValue;
    }
    if (typeof this.timeValue !== 'undefined' && this.timeValue !== null) {
      toReturn['timeValue'] = 'toApiJson' in this.timeValue ? this.timeValue.toApiJson() : this.timeValue;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddAssigneeRequest {
  static fromProto(proto) {
    let m = new AddAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddAttachmentRequest {
  static fromProto(proto) {
    let m = new AddAttachmentRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.attachment) {
      m.attachment = Attachment.fromProto(proto.attachment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddConversationRequest {
  static fromProto(proto) {
    let m = new AddConversationRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.persona) {
      m.persona = enumStringToValue$1(PersonaType, proto.persona);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.sendFrom !== 'undefined') {
      toReturn['sendFrom'] = this.sendFrom;
    }
    if (typeof this.sendTo !== 'undefined') {
      toReturn['sendTo'] = this.sendTo;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.persona !== 'undefined') {
      toReturn['persona'] = this.persona;
    }
    return toReturn;
  }
}
class AddCustomTagsRequest {
  static fromProto(proto) {
    let m = new AddCustomTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddHistoryRequest {
  static fromProto(proto) {
    let m = new AddHistoryRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddMultiAssigneeRequest {
  static fromProto(proto) {
    let m = new AddMultiAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.addRequests) {
      m.addRequests = proto.addRequests.map(AddAssigneeRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addRequests !== 'undefined' && this.addRequests !== null) {
      toReturn['addRequests'] = 'toApiJson' in this.addRequests ? this.addRequests.toApiJson() : this.addRequests;
    }
    return toReturn;
  }
}
class AddMultipleSubtasksRequest {
  static fromProto(proto) {
    let m = new AddMultipleSubtasksRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.subtaskRequests) {
      m.subtaskRequests = proto.subtaskRequests.map(AddSubtaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.subtaskRequests !== 'undefined' && this.subtaskRequests !== null) {
      toReturn['subtaskRequests'] = 'toApiJson' in this.subtaskRequests ? this.subtaskRequests.toApiJson() : this.subtaskRequests;
    }
    return toReturn;
  }
}
class AddSubtaskRequest {
  static fromProto(proto) {
    let m = new AddSubtaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class AddTagsRequest {
  static fromProto(proto) {
    let m = new AddTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class CommandResponse {
  static fromProto(proto) {
    let m = new CommandResponse();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class CountMetricResponse {
  static fromProto(proto) {
    let m = new CountMetricResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class DeleteMultiTaskRequest {
  static fromProto(proto) {
    let m = new DeleteMultiTaskRequest();
    m = Object.assign(m, proto);
    if (proto.deleteRequests) {
      m.deleteRequests = proto.deleteRequests.map(DeleteTaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.deleteRequests !== 'undefined' && this.deleteRequests !== null) {
      toReturn['deleteRequests'] = 'toApiJson' in this.deleteRequests ? this.deleteRequests.toApiJson() : this.deleteRequests;
    }
    return toReturn;
  }
}
class DeleteTaskRequest {
  static fromProto(proto) {
    let m = new DeleteTaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class MultiCommandRequestEvent {
  static fromProto(proto) {
    let m = new MultiCommandRequestEvent();
    m = Object.assign(m, proto);
    if (proto.generate) {
      m.generate = GenerateTaskRequest.fromProto(proto.generate);
    }
    if (proto.addSubtask) {
      m.addSubtask = AddSubtaskRequest.fromProto(proto.addSubtask);
    }
    if (proto.setTitle) {
      m.setTitle = SetTitleRequest.fromProto(proto.setTitle);
    }
    if (proto.setType) {
      m.setType = SetTypeRequest.fromProto(proto.setType);
    }
    if (proto.addAssignee) {
      m.addAssignee = AddAssigneeRequest.fromProto(proto.addAssignee);
    }
    if (proto.removeAssignee) {
      m.removeAssignee = RemoveAssigneeRequest.fromProto(proto.removeAssignee);
    }
    if (proto.setDueDate) {
      m.setDueDate = SetDueDateRequest.fromProto(proto.setDueDate);
    }
    if (proto.setStatus) {
      m.setStatus = SetStatusRequest.fromProto(proto.setStatus);
    }
    if (proto.setKeyValue) {
      m.setKeyValue = SetKeyValue.fromProto(proto.setKeyValue);
    }
    if (proto.addHistory) {
      m.addHistory = AddHistoryRequest.fromProto(proto.addHistory);
    }
    if (proto.addConversation) {
      m.addConversation = AddConversationRequest.fromProto(proto.addConversation);
    }
    if (proto.addTags) {
      m.addTags = AddTagsRequest.fromProto(proto.addTags);
    }
    if (proto.removeTags) {
      m.removeTags = RemoveTagsRequest.fromProto(proto.removeTags);
    }
    if (proto.setNotes) {
      m.setNotes = SetNotesRequest.fromProto(proto.setNotes);
    }
    if (proto.setDescription) {
      m.setDescription = SetDescriptionRequest.fromProto(proto.setDescription);
    }
    if (proto.delete) {
      m.delete = DeleteTaskRequest.fromProto(proto.delete);
    }
    if (proto.restore) {
      m.restore = RestoreTaskRequest.fromProto(proto.restore);
    }
    if (proto.reorder) {
      m.reorder = ReorderSubtaskRequest.fromProto(proto.reorder);
    }
    if (proto.addAttachment) {
      m.addAttachment = AddAttachmentRequest.fromProto(proto.addAttachment);
    }
    if (proto.removeAttachment) {
      m.removeAttachment = RemoveAttachmentRequest.fromProto(proto.removeAttachment);
    }
    if (proto.addCustomTags) {
      m.addCustomTags = AddCustomTagsRequest.fromProto(proto.addCustomTags);
    }
    if (proto.removeCustomTags) {
      m.removeCustomTags = RemoveCustomTagsRequest.fromProto(proto.removeCustomTags);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.generate !== 'undefined' && this.generate !== null) {
      toReturn['generate'] = 'toApiJson' in this.generate ? this.generate.toApiJson() : this.generate;
    }
    if (typeof this.addSubtask !== 'undefined' && this.addSubtask !== null) {
      toReturn['addSubtask'] = 'toApiJson' in this.addSubtask ? this.addSubtask.toApiJson() : this.addSubtask;
    }
    if (typeof this.setTitle !== 'undefined' && this.setTitle !== null) {
      toReturn['setTitle'] = 'toApiJson' in this.setTitle ? this.setTitle.toApiJson() : this.setTitle;
    }
    if (typeof this.setType !== 'undefined' && this.setType !== null) {
      toReturn['setType'] = 'toApiJson' in this.setType ? this.setType.toApiJson() : this.setType;
    }
    if (typeof this.addAssignee !== 'undefined' && this.addAssignee !== null) {
      toReturn['addAssignee'] = 'toApiJson' in this.addAssignee ? this.addAssignee.toApiJson() : this.addAssignee;
    }
    if (typeof this.removeAssignee !== 'undefined' && this.removeAssignee !== null) {
      toReturn['removeAssignee'] = 'toApiJson' in this.removeAssignee ? this.removeAssignee.toApiJson() : this.removeAssignee;
    }
    if (typeof this.setDueDate !== 'undefined' && this.setDueDate !== null) {
      toReturn['setDueDate'] = 'toApiJson' in this.setDueDate ? this.setDueDate.toApiJson() : this.setDueDate;
    }
    if (typeof this.setStatus !== 'undefined' && this.setStatus !== null) {
      toReturn['setStatus'] = 'toApiJson' in this.setStatus ? this.setStatus.toApiJson() : this.setStatus;
    }
    if (typeof this.setKeyValue !== 'undefined' && this.setKeyValue !== null) {
      toReturn['setKeyValue'] = 'toApiJson' in this.setKeyValue ? this.setKeyValue.toApiJson() : this.setKeyValue;
    }
    if (typeof this.addHistory !== 'undefined' && this.addHistory !== null) {
      toReturn['addHistory'] = 'toApiJson' in this.addHistory ? this.addHistory.toApiJson() : this.addHistory;
    }
    if (typeof this.addConversation !== 'undefined' && this.addConversation !== null) {
      toReturn['addConversation'] = 'toApiJson' in this.addConversation ? this.addConversation.toApiJson() : this.addConversation;
    }
    if (typeof this.addTags !== 'undefined' && this.addTags !== null) {
      toReturn['addTags'] = 'toApiJson' in this.addTags ? this.addTags.toApiJson() : this.addTags;
    }
    if (typeof this.removeTags !== 'undefined' && this.removeTags !== null) {
      toReturn['removeTags'] = 'toApiJson' in this.removeTags ? this.removeTags.toApiJson() : this.removeTags;
    }
    if (typeof this.setNotes !== 'undefined' && this.setNotes !== null) {
      toReturn['setNotes'] = 'toApiJson' in this.setNotes ? this.setNotes.toApiJson() : this.setNotes;
    }
    if (typeof this.setDescription !== 'undefined' && this.setDescription !== null) {
      toReturn['setDescription'] = 'toApiJson' in this.setDescription ? this.setDescription.toApiJson() : this.setDescription;
    }
    if (typeof this.delete !== 'undefined' && this.delete !== null) {
      toReturn['delete'] = 'toApiJson' in this.delete ? this.delete.toApiJson() : this.delete;
    }
    if (typeof this.restore !== 'undefined' && this.restore !== null) {
      toReturn['restore'] = 'toApiJson' in this.restore ? this.restore.toApiJson() : this.restore;
    }
    if (typeof this.reorder !== 'undefined' && this.reorder !== null) {
      toReturn['reorder'] = 'toApiJson' in this.reorder ? this.reorder.toApiJson() : this.reorder;
    }
    if (typeof this.addAttachment !== 'undefined' && this.addAttachment !== null) {
      toReturn['addAttachment'] = 'toApiJson' in this.addAttachment ? this.addAttachment.toApiJson() : this.addAttachment;
    }
    if (typeof this.removeAttachment !== 'undefined' && this.removeAttachment !== null) {
      toReturn['removeAttachment'] = 'toApiJson' in this.removeAttachment ? this.removeAttachment.toApiJson() : this.removeAttachment;
    }
    if (typeof this.addCustomTags !== 'undefined' && this.addCustomTags !== null) {
      toReturn['addCustomTags'] = 'toApiJson' in this.addCustomTags ? this.addCustomTags.toApiJson() : this.addCustomTags;
    }
    if (typeof this.removeCustomTags !== 'undefined' && this.removeCustomTags !== null) {
      toReturn['removeCustomTags'] = 'toApiJson' in this.removeCustomTags ? this.removeCustomTags.toApiJson() : this.removeCustomTags;
    }
    return toReturn;
  }
}
class GenerateTaskRequest {
  static fromProto(proto) {
    let m = new GenerateTaskRequest();
    m = Object.assign(m, proto);
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    if (proto.data) {
      m.data = KeyValues.fromProto(proto.data);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class GetMetricsFilters {
  static fromProto(proto) {
    let m = new GetMetricsFilters();
    m = Object.assign(m, proto);
    if (proto.rangeStart) {
      m.rangeStart = new Date(proto.rangeStart);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = new Date(proto.rangeEnd);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.dateRangeField) {
      m.dateRangeField = enumStringToValue$1(RangeField, proto.dateRangeField);
    }
    if (proto.metadataGroups) {
      m.metadataGroups = GroupedMetadata.fromProto(proto.metadataGroups);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPathFuzzy !== 'undefined') {
      toReturn['parentPathFuzzy'] = this.parentPathFuzzy;
    }
    if (typeof this.parentPathExact !== 'undefined') {
      toReturn['parentPathExact'] = this.parentPathExact;
    }
    if (typeof this.titleFuzzy !== 'undefined') {
      toReturn['titleFuzzy'] = this.titleFuzzy;
    }
    if (typeof this.titleExact !== 'undefined') {
      toReturn['titleExact'] = this.titleExact;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.rangeStart !== 'undefined' && this.rangeStart !== null) {
      toReturn['rangeStart'] = 'toApiJson' in this.rangeStart ? this.rangeStart.toApiJson() : this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined' && this.rangeEnd !== null) {
      toReturn['rangeEnd'] = 'toApiJson' in this.rangeEnd ? this.rangeEnd.toApiJson() : this.rangeEnd;
    }
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.dateRangeField !== 'undefined') {
      toReturn['dateRangeField'] = this.dateRangeField;
    }
    if (typeof this.access !== 'undefined') {
      toReturn['access'] = this.access;
    }
    if (typeof this.metadataGroups !== 'undefined' && this.metadataGroups !== null) {
      toReturn['metadataGroups'] = 'toApiJson' in this.metadataGroups ? this.metadataGroups.toApiJson() : this.metadataGroups;
    }
    return toReturn;
  }
}
class GetMetricsRequest {
  static fromProto(proto) {
    let m = new GetMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.requests) {
      m.requests = proto.requests.map(GetMetricsRequestMetricRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requests !== 'undefined' && this.requests !== null) {
      toReturn['requests'] = 'toApiJson' in this.requests ? this.requests.toApiJson() : this.requests;
    }
    return toReturn;
  }
}
class GetMetricsResponse {
  static fromProto(proto) {
    let m = new GetMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = proto.metrics.map(v => enumStringToValue$1(Metric, v));
    }
    if (proto.responses) {
      m.responses = proto.responses.map(MetricResponses.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metrics !== 'undefined') {
      toReturn['metrics'] = this.metrics;
    }
    if (typeof this.responses !== 'undefined' && this.responses !== null) {
      toReturn['responses'] = 'toApiJson' in this.responses ? this.responses.toApiJson() : this.responses;
    }
    if (typeof this.names !== 'undefined') {
      toReturn['names'] = this.names;
    }
    return toReturn;
  }
}
class GetTaskRequest {
  static fromProto(proto) {
    let m = new GetTaskRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.returnDeleted !== 'undefined') {
      toReturn['returnDeleted'] = this.returnDeleted;
    }
    return toReturn;
  }
}
class GetTaskResponse {
  static fromProto(proto) {
    let m = new GetTaskResponse();
    m = Object.assign(m, proto);
    if (proto.task) {
      m.task = Task.fromProto(proto.task);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.task !== 'undefined' && this.task !== null) {
      toReturn['task'] = 'toApiJson' in this.task ? this.task.toApiJson() : this.task;
    }
    return toReturn;
  }
}
class GetTasksRequest {
  static fromProto(proto) {
    let m = new GetTasksRequest();
    m = Object.assign(m, proto);
    if (proto.identities) {
      m.identities = proto.identities.map(TaskIdentity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identities !== 'undefined' && this.identities !== null) {
      toReturn['identities'] = 'toApiJson' in this.identities ? this.identities.toApiJson() : this.identities;
    }
    if (typeof this.returnDeleted !== 'undefined') {
      toReturn['returnDeleted'] = this.returnDeleted;
    }
    if (typeof this.excludeDeleted !== 'undefined') {
      toReturn['excludeDeleted'] = this.excludeDeleted;
    }
    return toReturn;
  }
}
class GetTasksResponse {
  static fromProto(proto) {
    let m = new GetTasksResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(Task.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    return toReturn;
  }
}
class GetTreeRequest {
  static fromProto(proto) {
    let m = new GetTreeRequest();
    m = Object.assign(m, proto);
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    return toReturn;
  }
}
class GetTreeResponse {
  static fromProto(proto) {
    let m = new GetTreeResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = TaskTree.fromProto(proto.tasks);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    return toReturn;
  }
}
class GroupedMetadata {
  static fromProto(proto) {
    let m = new GroupedMetadata();
    m = Object.assign(m, proto);
    if (proto.metadataGroup) {
      m.metadataGroup = proto.metadataGroup.map(KeyValues.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metadataGroup !== 'undefined' && this.metadataGroup !== null) {
      toReturn['metadataGroup'] = 'toApiJson' in this.metadataGroup ? this.metadataGroup.toApiJson() : this.metadataGroup;
    }
    return toReturn;
  }
}
class GroupedTags {
  static fromProto(proto) {
    let m = new GroupedTags();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(TagGroup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class GetMetricsRequestMetricRequest {
  static fromProto(proto) {
    let m = new GetMetricsRequestMetricRequest();
    m = Object.assign(m, proto);
    if (proto.metric) {
      m.metric = enumStringToValue$1(Metric, proto.metric);
    }
    if (proto.filters) {
      m.filters = GetMetricsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metric !== 'undefined') {
      toReturn['metric'] = this.metric;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class MetricResponsesMetricResponse {
  static fromProto(proto) {
    let m = new MetricResponsesMetricResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = CountMetricResponse.fromProto(proto.count);
    }
    if (proto.value) {
      m.value = ValueMetricResponse.fromProto(proto.value);
    }
    if (proto.subMetricResponses) {
      m.subMetricResponses = proto.subMetricResponses.map(MetricResponses.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined' && this.count !== null) {
      toReturn['count'] = 'toApiJson' in this.count ? this.count.toApiJson() : this.count;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    if (typeof this.subMetricResponses !== 'undefined' && this.subMetricResponses !== null) {
      toReturn['subMetricResponses'] = 'toApiJson' in this.subMetricResponses ? this.subMetricResponses.toApiJson() : this.subMetricResponses;
    }
    return toReturn;
  }
}
class MetricResponses {
  static fromProto(proto) {
    let m = new MetricResponses();
    m = Object.assign(m, proto);
    if (proto.metricResponses) {
      m.metricResponses = proto.metricResponses.map(MetricResponsesMetricResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricResponses !== 'undefined' && this.metricResponses !== null) {
      toReturn['metricResponses'] = 'toApiJson' in this.metricResponses ? this.metricResponses.toApiJson() : this.metricResponses;
    }
    return toReturn;
  }
}
class MultiCommandRequest {
  static fromProto(proto) {
    let m = new MultiCommandRequest();
    m = Object.assign(m, proto);
    if (proto.events) {
      m.events = proto.events.map(MultiCommandRequestEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.events !== 'undefined' && this.events !== null) {
      toReturn['events'] = 'toApiJson' in this.events ? this.events.toApiJson() : this.events;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class MultiCommandResponsesMultiCommandResponse {
  static fromProto(proto) {
    let m = new MultiCommandResponsesMultiCommandResponse();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    return toReturn;
  }
}
class MultiCommandResponses {
  static fromProto(proto) {
    let m = new MultiCommandResponses();
    m = Object.assign(m, proto);
    if (proto.responses) {
      m.responses = proto.responses.map(MultiCommandResponsesMultiCommandResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.responses !== 'undefined' && this.responses !== null) {
      toReturn['responses'] = 'toApiJson' in this.responses ? this.responses.toApiJson() : this.responses;
    }
    return toReturn;
  }
}
class MultiSearchTaskRequest {
  static fromProto(proto) {
    let m = new MultiSearchTaskRequest();
    m = Object.assign(m, proto);
    if (proto.searchRequests) {
      m.searchRequests = proto.searchRequests.map(SearchTaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchRequests !== 'undefined' && this.searchRequests !== null) {
      toReturn['searchRequests'] = 'toApiJson' in this.searchRequests ? this.searchRequests.toApiJson() : this.searchRequests;
    }
    return toReturn;
  }
}
class RemoveAssigneeRequest {
  static fromProto(proto) {
    let m = new RemoveAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RemoveAttachmentRequest {
  static fromProto(proto) {
    let m = new RemoveAttachmentRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.attachment) {
      m.attachment = Attachment.fromProto(proto.attachment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RemoveCustomTagsRequest {
  static fromProto(proto) {
    let m = new RemoveCustomTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RemoveMultiAssigneeRequest {
  static fromProto(proto) {
    let m = new RemoveMultiAssigneeRequest();
    m = Object.assign(m, proto);
    if (proto.removeRequests) {
      m.removeRequests = proto.removeRequests.map(RemoveAssigneeRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.removeRequests !== 'undefined' && this.removeRequests !== null) {
      toReturn['removeRequests'] = 'toApiJson' in this.removeRequests ? this.removeRequests.toApiJson() : this.removeRequests;
    }
    return toReturn;
  }
}
class RemoveTagsRequest {
  static fromProto(proto) {
    let m = new RemoveTagsRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class ReorderSubtaskRequest {
  static fromProto(proto) {
    let m = new ReorderSubtaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.currentPosition) {
      m.currentPosition = parseInt(proto.currentPosition, 10);
    }
    if (proto.newPosition) {
      m.newPosition = parseInt(proto.newPosition, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.currentPosition !== 'undefined') {
      toReturn['currentPosition'] = this.currentPosition;
    }
    if (typeof this.newPosition !== 'undefined') {
      toReturn['newPosition'] = this.newPosition;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class RestoreMultiTaskRequest {
  static fromProto(proto) {
    let m = new RestoreMultiTaskRequest();
    m = Object.assign(m, proto);
    if (proto.restoreRequests) {
      m.restoreRequests = proto.restoreRequests.map(RestoreTaskRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.restoreRequests !== 'undefined' && this.restoreRequests !== null) {
      toReturn['restoreRequests'] = 'toApiJson' in this.restoreRequests ? this.restoreRequests.toApiJson() : this.restoreRequests;
    }
    return toReturn;
  }
}
class RestoreTaskRequest {
  static fromProto(proto) {
    let m = new RestoreTaskRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SearchTaskRequest {
  static fromProto(proto) {
    let m = new SearchTaskRequest();
    m = Object.assign(m, proto);
    if (proto.rangeStart) {
      m.rangeStart = new Date(proto.rangeStart);
    }
    if (proto.rangeEnd) {
      m.rangeEnd = new Date(proto.rangeEnd);
    }
    if (proto.metadata) {
      m.metadata = KeyValues.fromProto(proto.metadata);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue$1(SortDirection, proto.sortDirection);
    }
    if (proto.dateRangeField) {
      m.dateRangeField = enumStringToValue$1(RangeField, proto.dateRangeField);
    }
    if (proto.sorts) {
      m.sorts = proto.sorts.map(Sort.fromProto);
    }
    if (proto.tagGroups) {
      m.tagGroups = GroupedTags.fromProto(proto.tagGroups);
    }
    if (proto.metadataGroups) {
      m.metadataGroups = GroupedMetadata.fromProto(proto.metadataGroups);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentPathFuzzy !== 'undefined') {
      toReturn['parentPathFuzzy'] = this.parentPathFuzzy;
    }
    if (typeof this.parentPathExact !== 'undefined') {
      toReturn['parentPathExact'] = this.parentPathExact;
    }
    if (typeof this.titleFuzzy !== 'undefined') {
      toReturn['titleFuzzy'] = this.titleFuzzy;
    }
    if (typeof this.titleExact !== 'undefined') {
      toReturn['titleExact'] = this.titleExact;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.rangeStart !== 'undefined' && this.rangeStart !== null) {
      toReturn['rangeStart'] = 'toApiJson' in this.rangeStart ? this.rangeStart.toApiJson() : this.rangeStart;
    }
    if (typeof this.rangeEnd !== 'undefined' && this.rangeEnd !== null) {
      toReturn['rangeEnd'] = 'toApiJson' in this.rangeEnd ? this.rangeEnd.toApiJson() : this.rangeEnd;
    }
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    if (typeof this.dateRangeField !== 'undefined') {
      toReturn['dateRangeField'] = this.dateRangeField;
    }
    if (typeof this.access !== 'undefined') {
      toReturn['access'] = this.access;
    }
    if (typeof this.sorts !== 'undefined' && this.sorts !== null) {
      toReturn['sorts'] = 'toApiJson' in this.sorts ? this.sorts.toApiJson() : this.sorts;
    }
    if (typeof this.excludeHistory !== 'undefined') {
      toReturn['excludeHistory'] = this.excludeHistory;
    }
    if (typeof this.deletedOnly !== 'undefined') {
      toReturn['deletedOnly'] = this.deletedOnly;
    }
    if (typeof this.tagGroups !== 'undefined' && this.tagGroups !== null) {
      toReturn['tagGroups'] = 'toApiJson' in this.tagGroups ? this.tagGroups.toApiJson() : this.tagGroups;
    }
    if (typeof this.metadataGroups !== 'undefined' && this.metadataGroups !== null) {
      toReturn['metadataGroups'] = 'toApiJson' in this.metadataGroups ? this.metadataGroups.toApiJson() : this.metadataGroups;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.customTags !== 'undefined') {
      toReturn['customTags'] = this.customTags;
    }
    return toReturn;
  }
}
class SearchTaskResponse {
  static fromProto(proto) {
    let m = new SearchTaskResponse();
    m = Object.assign(m, proto);
    if (proto.tasks) {
      m.tasks = proto.tasks.map(Task.fromProto);
    }
    if (proto.hits) {
      m.hits = parseInt(proto.hits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tasks !== 'undefined' && this.tasks !== null) {
      toReturn['tasks'] = 'toApiJson' in this.tasks ? this.tasks.toApiJson() : this.tasks;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.hits !== 'undefined') {
      toReturn['hits'] = this.hits;
    }
    return toReturn;
  }
}
class SetDescriptionRequest {
  static fromProto(proto) {
    let m = new SetDescriptionRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetDueDateRequest {
  static fromProto(proto) {
    let m = new SetDueDateRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetKeyValue {
  static fromProto(proto) {
    let m = new SetKeyValue();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.keyValueData) {
      m.keyValueData = KeyValues.fromProto(proto.keyValueData);
    }
    if (proto.field) {
      m.field = enumStringToValue$1(KeyValueField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.keyValueData !== 'undefined' && this.keyValueData !== null) {
      toReturn['keyValueData'] = 'toApiJson' in this.keyValueData ? this.keyValueData.toApiJson() : this.keyValueData;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class SetKeyValuesRequest {
  static fromProto(proto) {
    let m = new SetKeyValuesRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    if (proto.keyValueData) {
      m.keyValueData = KeyValues.fromProto(proto.keyValueData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.keyValueData !== 'undefined' && this.keyValueData !== null) {
      toReturn['keyValueData'] = 'toApiJson' in this.keyValueData ? this.keyValueData.toApiJson() : this.keyValueData;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetMultiDueDateRequest {
  static fromProto(proto) {
    let m = new SetMultiDueDateRequest();
    m = Object.assign(m, proto);
    if (proto.dueDateRequests) {
      m.dueDateRequests = proto.dueDateRequests.map(SetDueDateRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dueDateRequests !== 'undefined' && this.dueDateRequests !== null) {
      toReturn['dueDateRequests'] = 'toApiJson' in this.dueDateRequests ? this.dueDateRequests.toApiJson() : this.dueDateRequests;
    }
    return toReturn;
  }
}
class SetMultiNotesRequest {
  static fromProto(proto) {
    let m = new SetMultiNotesRequest();
    m = Object.assign(m, proto);
    if (proto.notesRequests) {
      m.notesRequests = proto.notesRequests.map(SetNotesRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.notesRequests !== 'undefined' && this.notesRequests !== null) {
      toReturn['notesRequests'] = 'toApiJson' in this.notesRequests ? this.notesRequests.toApiJson() : this.notesRequests;
    }
    return toReturn;
  }
}
class SetMultiStatusRequest {
  static fromProto(proto) {
    let m = new SetMultiStatusRequest();
    m = Object.assign(m, proto);
    if (proto.statusRequests) {
      m.statusRequests = proto.statusRequests.map(SetStatusRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusRequests !== 'undefined' && this.statusRequests !== null) {
      toReturn['statusRequests'] = 'toApiJson' in this.statusRequests ? this.statusRequests.toApiJson() : this.statusRequests;
    }
    return toReturn;
  }
}
class SetNotesRequest {
  static fromProto(proto) {
    let m = new SetNotesRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetStatusRequest {
  static fromProto(proto) {
    let m = new SetStatusRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetTitleRequest {
  static fromProto(proto) {
    let m = new SetTitleRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class SetTypeRequest {
  static fromProto(proto) {
    let m = new SetTypeRequest();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.identity) {
      m.identity = TaskIdentity.fromProto(proto.identity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.identity !== 'undefined' && this.identity !== null) {
      toReturn['identity'] = 'toApiJson' in this.identity ? this.identity.toApiJson() : this.identity;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.callerSubjectId !== 'undefined') {
      toReturn['callerSubjectId'] = this.callerSubjectId;
    }
    return toReturn;
  }
}
class Sort {
  static fromProto(proto) {
    let m = new Sort();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$1(SortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class TagGroup {
  static fromProto(proto) {
    let m = new TagGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class ValueMetricResponse {
  static fromProto(proto) {
    let m = new ValueMetricResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}

// *********************************

const environment$1 = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'task-demo.apigateway.co',
  'test': '',
  'demo': 'task-api-demo.apigateway.co',
  'prod': 'task-api-prod.apigateway.co',
  'production': 'task-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment$1.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TaskCommandApiService = /*#__PURE__*/(() => {
  class TaskCommandApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generate(r) {
      const request = r.toApiJson ? r : new GenerateTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/Generate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addSubtask(r) {
      const request = r.toApiJson ? r : new AddSubtaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddSubtask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addMultipleSubtasks(r) {
      const request = r.toApiJson ? r : new AddMultipleSubtasksRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddMultipleSubtasks", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setTitle(r) {
      const request = r.toApiJson ? r : new SetTitleRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetTitle", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setStatus(r) {
      const request = r.toApiJson ? r : new SetStatusRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setMultiStatus(r) {
      const request = r.toApiJson ? r : new SetMultiStatusRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetMultiStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setDueDate(r) {
      const request = r.toApiJson ? r : new SetDueDateRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetDueDate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setMultiDueDate(r) {
      const request = r.toApiJson ? r : new SetMultiDueDateRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetMultiDueDate", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    addAssignee(r) {
      const request = r.toApiJson ? r : new AddAssigneeRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddAssignee", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addMultiAssignee(r) {
      const request = r.toApiJson ? r : new AddMultiAssigneeRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddMultiAssignee", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    removeAssignee(r) {
      const request = r.toApiJson ? r : new RemoveAssigneeRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RemoveAssignee", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeMultiAssignee(r) {
      const request = r.toApiJson ? r : new RemoveMultiAssigneeRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RemoveMultiAssignee", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    addTags(r) {
      const request = r.toApiJson ? r : new AddTagsRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeTags(r) {
      const request = r.toApiJson ? r : new RemoveTagsRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RemoveTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addCustomTags(r) {
      const request = r.toApiJson ? r : new AddCustomTagsRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddCustomTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeCustomTags(r) {
      const request = r.toApiJson ? r : new RemoveCustomTagsRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RemoveCustomTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setNotes(r) {
      const request = r.toApiJson ? r : new SetNotesRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetNotes", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setMultiNotes(r) {
      const request = r.toApiJson ? r : new SetMultiNotesRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetMultiNotes", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setDescription(r) {
      const request = r.toApiJson ? r : new SetDescriptionRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetDescription", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addHistory(r) {
      const request = r.toApiJson ? r : new AddHistoryRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddHistory", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    deleteTask(r) {
      const request = r.toApiJson ? r : new DeleteTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/DeleteTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    deleteMultiTask(r) {
      const request = r.toApiJson ? r : new DeleteMultiTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/DeleteMultiTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    restoreTask(r) {
      const request = r.toApiJson ? r : new RestoreTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RestoreTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    restoreMultiTask(r) {
      const request = r.toApiJson ? r : new RestoreMultiTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RestoreMultiTask", request.toApiJson(), this.apiOptions()).pipe(map(resp => MultiCommandResponses.fromProto(resp)));
    }
    setData(r) {
      const request = r.toApiJson ? r : new SetKeyValuesRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetData", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setMetadata(r) {
      const request = r.toApiJson ? r : new SetKeyValuesRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addConversation(r) {
      const request = r.toApiJson ? r : new AddConversationRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    reorderSubtask(r) {
      const request = r.toApiJson ? r : new ReorderSubtaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/ReorderSubtask", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    addAttachment(r) {
      const request = r.toApiJson ? r : new AddAttachmentRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/AddAttachment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    removeAttachment(r) {
      const request = r.toApiJson ? r : new RemoveAttachmentRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/RemoveAttachment", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    setType(r) {
      const request = r.toApiJson ? r : new SetTypeRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/SetType", request.toApiJson(), this.apiOptions()).pipe(map(resp => CommandResponse.fromProto(resp)));
    }
    multiCommand(r) {
      const request = r.toApiJson ? r : new MultiCommandRequest(r);
      return this.http.post(this._host + "/task.v1.TaskCommand/MultiCommand", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TaskCommandApiService.ɵfac = function TaskCommandApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TaskCommandApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskCommandApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskCommandApiService,
    factory: TaskCommandApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskCommandApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TaskQueryApiService = /*#__PURE__*/(() => {
  class TaskQueryApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskQuery/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetTasksRequest(r);
      return this.http.post(this._host + "/task.v1.TaskQuery/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTasksResponse.fromProto(resp)));
    }
    getTree(r) {
      const request = r.toApiJson ? r : new GetTreeRequest(r);
      return this.http.post(this._host + "/task.v1.TaskQuery/GetTree", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTreeResponse.fromProto(resp)));
    }
    search(r) {
      const request = r.toApiJson ? r : new SearchTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskQuery/Search", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchTaskResponse.fromProto(resp)));
    }
    multiSearch(r) {
      const request = r.toApiJson ? r : new MultiSearchTaskRequest(r);
      return this.http.post(this._host + "/task.v1.TaskQuery/MultiSearch", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchTaskResponse.fromProto(resp)));
    }
    getMetrics(r) {
      const request = r.toApiJson ? r : new GetMetricsRequest(r);
      return this.http.post(this._host + "/task.v1.TaskQuery/GetMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMetricsResponse.fromProto(resp)));
    }
  }
  TaskQueryApiService.ɵfac = function TaskQueryApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TaskQueryApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  TaskQueryApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskQueryApiService,
    factory: TaskQueryApiService.ɵfac,
    providedIn: 'root'
  });
  return TaskQueryApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

var Persona = /*#__PURE__*/function (Persona) {
  Persona["salesPerson"] = "sales_person";
  Persona["digitalAgent"] = "digital_agent";
  return Persona;
}(Persona || {});
var GoType = /*#__PURE__*/function (GoType) {
  GoType["STRING"] = "string";
  GoType["INT"] = "int64";
  GoType["FLOAT"] = "float64";
  GoType["BOOL"] = "bool";
  GoType["TIME"] = "time";
  return GoType;
}(GoType || {});
/**
 * Enum of the standard Task statuses. No longer enforced as the only allowable statuses
 */
var Status = /*#__PURE__*/function (Status) {
  Status["Open"] = "Open";
  Status["InProgress"] = "In Progress";
  Status["WaitingOnCustomer"] = "Waiting on Customer";
  Status["Completed"] = "Completed";
  return Status;
}(Status || {});
var KeyValueTypes = /*#__PURE__*/function (KeyValueTypes) {
  KeyValueTypes["INT64"] = "int64";
  KeyValueTypes["DOUBLE"] = "double";
  KeyValueTypes["BOOL"] = "bool";
  KeyValueTypes["STRING"] = "string";
  KeyValueTypes["TIME"] = "time";
  return KeyValueTypes;
}(KeyValueTypes || {});
const TASK_DELIM = '/';
function buildNamespace(keyValuePairs) {
  const pairs = new Array();
  Object.keys(keyValuePairs).forEach(key => {
    const value = keyValuePairs[key];
    if (value.includes(TASK_DELIM) || key.includes(TASK_DELIM)) {
      throw new Error('keys/values cannot contain slashes');
    }
    if (typeof value !== 'string') {
      throw new TypeError('values must be strings');
    }
    pairs.push(key + TASK_DELIM + value);
  });
  return pairs.join(TASK_DELIM);
}
function buildParentPath(taskIds) {
  return taskIds.reduce((path, value) => {
    if (value.includes(TASK_DELIM)) {
      throw new Error('values cannot contain slashes');
    }
    return path + value + TASK_DELIM;
  }, TASK_DELIM);
}
function newGuid() {
  return uuid.v4().replace(/-/g, '');
}
let TaskSdkService = /*#__PURE__*/(() => {
  class TaskSdkService {
    static buildAccountGroupNamespace(partnerId, accountGroupId) {
      return buildNamespace({
        partner: partnerId,
        'account-group': accountGroupId
      });
    }
    static buildPartnerNamespace(partnerId) {
      return buildNamespace({
        partner: partnerId
      });
    }
    static generateTaskId() {
      return 'TK-' + newGuid();
    }
    constructor(commandApi, queryApi) {
      this.commandApi = commandApi;
      this.queryApi = queryApi;
    }
    generate(args) {
      const access = new KeyValuesKeyValue({
        key: 'access',
        values: [{
          stringValue: args.access,
          type: GoType.STRING
        }]
      });
      let metadata = {
        keyValues: [access]
      };
      if (args.metadata && args.metadata.keyValues) {
        args.metadata.keyValues.push(access);
        metadata = {
          keyValues: args.metadata.keyValues
        };
      }
      args.metadata = new KeyValues(metadata);
      return this.commandApi.generate(new GenerateTaskRequest(args)).pipe(map(res => res.version));
    }
    addSubTask(args) {
      const metadata = args.metadata ? DomainKeyValue.fromKeyValue(args.metadata) : new DomainKeyValue();
      metadata.set('access', [args.access], KeyValueTypes.STRING);
      args.metadata = metadata.toKeyValue();
      return this.commandApi.addSubtask(new AddSubtaskRequest(args)).pipe(map(res => res.version));
    }
    addMultipleSubtasks(addMultipleSubtaskRequests) {
      const requests = addMultipleSubtaskRequests?.subtaskRequests?.map(value => {
        const metadata = value.metadata ? DomainKeyValue.fromKeyValue(value.metadata) : new DomainKeyValue();
        metadata.set('access', [value.access], KeyValueTypes.STRING);
        value.metadata = metadata.toKeyValue();
        return new AddSubtaskRequest(value).toApiJson();
      });
      return this.commandApi.addMultipleSubtasks(new AddMultipleSubtasksRequest({
        subtaskRequests: requests
      })).pipe(map(res => res.version ?? 0));
    }
    /**
     * Gets the task matching the given identity
     * Since data is only soft deleted Getting a deleted Task will return the task, it is up to the client to ignore them
     */
    getTask(namespace, parentPath, taskId, returnDeleted) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new GetTaskRequest({
        identity: identity,
        returnDeleted: returnDeleted
      });
      return this.queryApi.get(request).pipe(map(res => res.task));
    }
    /**
     * Gets a task, will include all the subtasks on the object as well
     * Since data is only soft deleted Getting a deleted Task will return the task, it is up to the client to ignore them
     */
    getTree(namespace, parentPath, taskId) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new GetTreeRequest({
        identity
      });
      return this.queryApi.getTree(request).pipe(map(res => res.tasks));
    }
    setTitle(namespace, parentPath, taskId, newTitle, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new SetTitleRequest({
        identity: identity,
        title: newTitle,
        version: newVersion
      });
      return this.commandApi.setTitle(request).pipe(map(res => res.version));
    }
    setStatus(namespace, parentPath, taskId, newStatus, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new SetStatusRequest({
        status: newStatus,
        identity: identity,
        version: newVersion
      });
      return this.commandApi.setStatus(request).pipe(map(res => res.version));
    }
    setMultipleStatus(requests) {
      const multiReq = new SetMultiStatusRequest({
        statusRequests: requests
      });
      return this.commandApi.setMultiStatus(multiReq);
    }
    setDueDate(namespace, parentPath, taskId, newDueDate, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new SetDueDateRequest({
        identity: identity,
        dueDate: newDueDate,
        version: newVersion
      });
      return this.commandApi.setDueDate(request).pipe(map(res => res.version));
    }
    setMultipleDueDates(requests) {
      const multiReq = new SetMultiDueDateRequest({
        dueDateRequests: requests
      });
      return this.commandApi.setMultiDueDate(multiReq);
    }
    setDescription(namespace, parentPath, taskId, newDescription, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new SetDescriptionRequest({
        identity: identity,
        description: newDescription,
        version: newVersion
      });
      return this.commandApi.setDescription(request).pipe(map(res => res.version));
    }
    addHistory(namespace, parentPath, taskId, message, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new AddHistoryRequest({
        identity: identity,
        message: message,
        version: newVersion
      });
      return this.commandApi.addHistory(request).pipe(map(res => res.version));
    }
    addAssignee(namespace, parentPath, taskId, assignee, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new AddAssigneeRequest({
        identity: identity,
        assignee: assignee,
        version: newVersion
      });
      return this.commandApi.addAssignee(request).pipe(map(res => res.version));
    }
    addMultipleAssignees(requests) {
      const add = new AddMultiAssigneeRequest({
        addRequests: requests
      });
      return this.commandApi.addMultiAssignee(add);
    }
    removeAssignee(namespace, parentPath, taskId, assignee, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new RemoveAssigneeRequest({
        identity: identity,
        assignee: assignee,
        version: newVersion
      });
      return this.commandApi.removeAssignee(request).pipe(map(res => res.version));
    }
    removeMultipleAssignees(requests) {
      const rem = new RemoveMultiAssigneeRequest({
        removeRequests: requests
      });
      return this.commandApi.removeMultiAssignee(rem);
    }
    addTags(namespace, parentPath, taskId, newTags, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new AddTagsRequest({
        identity: identity,
        tags: newTags,
        version: newVersion
      });
      return this.commandApi.addTags(request).pipe(map(res => res.version));
    }
    removeTags(namespace, parentPath, taskId, removeTags, newVersion) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new RemoveTagsRequest({
        identity: identity,
        tags: removeTags,
        version: newVersion
      });
      return this.commandApi.removeTags(request).pipe(map(res => res.version));
    }
    reorderTask(namespace, parentPath, taskId, currentPosition, newPosition, version) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new ReorderSubtaskRequest({
        identity: identity,
        currentPosition: currentPosition,
        newPosition: newPosition,
        version: version
      });
      return this.commandApi.reorderSubtask(request).pipe(map(res => res.version));
    }
    deleteTask(namespace, parentPath, taskId, version) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new DeleteTaskRequest({
        identity,
        version
      });
      return this.commandApi.deleteTask(request).pipe(map(res => res.version));
    }
    deleteMultipleTasks(requests) {
      const del = new DeleteMultiTaskRequest({
        deleteRequests: requests
      });
      return this.commandApi.deleteMultiTask(del);
    }
    restoreTask(namespace, parentPath, taskId, version) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const request = new RestoreTaskRequest({
        identity,
        version
      });
      return this.commandApi.restoreTask(request).pipe(map(res => res.version));
    }
    restoreMultipleTasks(requests) {
      const req = new RestoreMultiTaskRequest({
        restoreRequests: requests
      });
      return this.commandApi.restoreMultiTask(req);
    }
    addAttachment(namespace, parentPath, taskId, attachment) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const req = new AddAttachmentRequest({
        identity,
        attachment
      });
      return this.commandApi.addAttachment(req).pipe(map(res => res.version));
    }
    removeAttachment(namespace, parentPath, taskId, attachment) {
      const identity = new TaskIdentity({
        namespace,
        parentPath,
        taskId
      });
      const req = new RemoveAttachmentRequest({
        identity,
        attachment
      });
      return this.commandApi.removeAttachment(req).pipe(map(res => res.version));
    }
    multiCommand(events) {
      const req = new MultiCommandRequest({
        events
      });
      return this.commandApi.multiCommand(req).pipe(mapTo(null));
    }
    search(request) {
      return this.queryApi.search(request);
    }
    multiProductSearch(request) {
      const multiReq = new MultiSearchTaskRequest();
      multiReq.searchRequests = [];
      const requestMetadata = DomainKeyValue.fromKeyValue(request.metadata);
      const productIds = request.productIds;
      productIds.forEach(productId => {
        const searchRequest = new SearchTaskRequest(request);
        searchRequest.metadata = new KeyValues(requestMetadata.set('ProductId', [productId], KeyValueTypes.STRING).toKeyValue());
        multiReq.searchRequests.push(searchRequest);
      });
      return this.queryApi.multiSearch(multiReq);
    }
    multiPartnerSearch(request) {
      const multiReq = new MultiSearchTaskRequest();
      multiReq.searchRequests = [];
      const requestMetadata = DomainKeyValue.fromKeyValue(request.metadata);
      const partnerIds = request.partnerIds;
      partnerIds.forEach(partnerId => {
        const searchRequest = new SearchTaskRequest(request);
        searchRequest.metadata = new KeyValues(requestMetadata.set('partner', [partnerId], KeyValueTypes.STRING).toKeyValue());
        multiReq.searchRequests.push(searchRequest);
      });
      return this.queryApi.multiSearch(multiReq);
    }
    /**
     * Gets the tasks matching the given identities
     * Since data is only soft deleted Getting a deleted Task will return the task, it is up to the client to ignore them
     */
    getMulti(request) {
      return this.queryApi.getMulti(request);
    }
    /**
     * Get a single Task Metric (aggregation query) from the Enum of available aggregations
     * @param metric - the metric you wish to request
     * @param filters - any filters to be applied
     */
    getMetric(metric, filters) {
      const request = {
        requests: [{
          metric,
          filters,
          name: 'metric'
        }]
      };
      return this.queryApi.getMetrics(request).pipe(map(r => {
        return r.responses[0].metricResponses;
      }));
    }
    /**
     * Issue a command to set values on the Data field of a Task, note the setdata command is not a clobber operation,
     * only keys specified on the request will be updated
     */
    setData(request) {
      return this.commandApi.setData(request).pipe(map(res => res.version));
    }
    /**
     * Issue a command to set values on the MetaData field of a Task, note the setMetadata command is not a clobber
     * operation, only keys specified on the request will be updated
     */
    setMetadata(request) {
      return this.commandApi.setMetadata(request).pipe(map(res => res.version));
    }
    setMultipleNotes(requests) {
      const multiReq = new SetMultiNotesRequest({
        notesRequests: requests
      });
      return this.commandApi.setMultiNotes(multiReq);
    }
    addConversation(request) {
      return this.commandApi.addConversation(request);
    }
    setType(request) {
      return this.commandApi.setType(request);
    }
  }
  TaskSdkService.ɵfac = function TaskSdkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TaskSdkService)(i0.ɵɵinject(TaskCommandApiService), i0.ɵɵinject(TaskQueryApiService));
  };
  TaskSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskSdkService,
    factory: TaskSdkService.ɵfac,
    providedIn: 'root'
  });
  return TaskSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DomainKeyValue = /*#__PURE__*/(() => {
  class DomainKeyValue {
    /**
     * Convert a KeyValuesInterface to DomainKeyValue
     */
    static fromKeyValue(keyValues) {
      const result = new DomainKeyValue();
      const flattenedKeyValues = [];
      if (!keyValues) {
        keyValues = {
          keyValues: []
        };
      }
      if (!keyValues.keyValues) {
        return result;
      }
      for (const keyValue of keyValues.keyValues) {
        const key = keyValue.key;
        const flattenedKeyValue = {
          key: key,
          stringValues: [],
          boolValues: [],
          int64Values: [],
          doubleValues: [],
          timeValues: []
        };
        if (keyValue.values) {
          for (const value of keyValue.values) {
            if (value.stringValue !== undefined && value.stringValue !== null) {
              flattenedKeyValue.stringValues.push(value.stringValue);
            } else if (value.boolValue !== undefined && value.boolValue !== null) {
              flattenedKeyValue.boolValues.push(value.boolValue);
            } else if (value.int64Value !== undefined && value.int64Value !== null) {
              flattenedKeyValue.int64Values.push(value.int64Value);
            } else if (value.doubleValue !== undefined && value.doubleValue !== null) {
              flattenedKeyValue.doubleValues.push(value.doubleValue);
            } else if (value.timeValue !== undefined && value.timeValue !== null) {
              flattenedKeyValue.timeValues.push(value.timeValue);
            }
          }
          flattenedKeyValues.push(flattenedKeyValue);
        }
      }
      result.keyValues = flattenedKeyValues;
      return result;
    }
    constructor() {
      this.keyValues = [];
    }
    set(key, values, type) {
      if (values !== null && values.length > 0) {
        for (const keyValue of this.keyValues) {
          if (keyValue.key === key) {
            switch (type) {
              case KeyValueTypes.BOOL:
                keyValue.boolValues = values;
                break;
              case KeyValueTypes.DOUBLE:
                keyValue.doubleValues = values;
                break;
              case KeyValueTypes.INT64:
                keyValue.int64Values = values;
                break;
              case KeyValueTypes.STRING:
                keyValue.stringValues = values;
                break;
              case KeyValueTypes.TIME:
                keyValue.timeValues = values;
                break;
            }
            return this;
          }
        }
        const typeValues = {
          key: key,
          boolValues: [],
          stringValues: [],
          int64Values: [],
          doubleValues: [],
          timeValues: []
        };
        switch (type) {
          case KeyValueTypes.BOOL:
            typeValues.boolValues = values;
            break;
          case KeyValueTypes.DOUBLE:
            typeValues.doubleValues = values;
            break;
          case KeyValueTypes.INT64:
            typeValues.int64Values = values;
            break;
          case KeyValueTypes.STRING:
            typeValues.stringValues = values;
            break;
          case KeyValueTypes.TIME:
            typeValues.timeValues = values;
            break;
        }
        this.keyValues.push(typeValues);
      }
      return this;
    }
    get(key, type) {
      for (const keyValue of this.keyValues) {
        if (keyValue.key === key) {
          switch (type) {
            case KeyValueTypes.BOOL:
              return keyValue.boolValues;
            case KeyValueTypes.DOUBLE:
              return keyValue.doubleValues;
            case KeyValueTypes.INT64:
              return keyValue.int64Values;
            case KeyValueTypes.STRING:
              return keyValue.stringValues;
            case KeyValueTypes.TIME:
              return keyValue.timeValues;
          }
        }
      }
      return [];
    }
    /**
     * Convert current instance of DomainKeyValue to KeyValuesInterface that can be used for making SetData requests.
     * If a key has no values that key will not appear on the returned KeyValuesInterface
     */
    toKeyValue() {
      const keyValues = new KeyValues({
        keyValues: []
      });
      for (const flattenedKeyValue of this.keyValues) {
        const keyValue = new KeyValuesKeyValue({
          key: flattenedKeyValue.key,
          values: []
        });
        if (flattenedKeyValue.stringValues) {
          for (const val of flattenedKeyValue.stringValues) {
            keyValue.values.push(new KeyValuesKeyValueValue({
              stringValue: val,
              type: KeyValueTypes.STRING
            }));
          }
        }
        if (flattenedKeyValue.boolValues) {
          for (const val of flattenedKeyValue.boolValues) {
            keyValue.values.push(new KeyValuesKeyValueValue({
              boolValue: val,
              type: KeyValueTypes.BOOL
            }));
          }
        }
        if (flattenedKeyValue.int64Values) {
          for (const val of flattenedKeyValue.int64Values) {
            keyValue.values.push(new KeyValuesKeyValueValue({
              int64Value: val,
              type: KeyValueTypes.INT64
            }));
          }
        }
        if (flattenedKeyValue.doubleValues) {
          for (const val of flattenedKeyValue.doubleValues) {
            keyValue.values.push(new KeyValuesKeyValueValue({
              doubleValue: val,
              type: KeyValueTypes.DOUBLE
            }));
          }
        }
        if (flattenedKeyValue.timeValues) {
          for (const val of flattenedKeyValue.timeValues) {
            keyValue.values.push(new KeyValuesKeyValueValue({
              timeValue: val,
              type: KeyValueTypes.TIME
            }));
          }
        }
        if (keyValue.values.length > 0) {
          keyValues.keyValues.push(keyValue);
        }
      }
      return keyValues;
    }
  }
  DomainKeyValue.ɵfac = function DomainKeyValue_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DomainKeyValue)();
  };
  DomainKeyValue.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DomainKeyValue,
    factory: DomainKeyValue.ɵfac,
    providedIn: 'root'
  });
  return DomainKeyValue;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const SUPPORTED_DOC_FILE_TYPES = ['application/pdf', 'application/vnd.ms-excel', 'application/vnd.ms-excel.addin.macroEnabled.12', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12', 'application/vnd.ms-excel.sheet.macroEnabled.12', 'application/vnd.ms-excel.template.macroEnabled.12', 'application/vnd.ms-powerpoint', 'application/vnd.ms-powerpoint.addin.macroEnabled.12', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12', 'application/vnd.ms-powerpoint.slide.macroEnabled.12', 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12', 'application/vnd.ms-powerpoint.template.macroEnabled.12', 'application/msword', 'application/vnd.ms-word.document.macroEnabled.12', 'application/vnd.ms-word.template.macroEnabled.12', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.presentationml.slide', 'application/vnd.openxmlformats-officedocument.presentationml.slide+xml', 'application/vnd.openxmlformats-officedocument.presentationml.slideshow', 'application/vnd.openxmlformats-officedocument.presentationml.template', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.spreadsheetml.template', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'];
const AttachmentServiceDataInterfaceToken = new InjectionToken('task-sdk AttachmentServiceDataInterfaceToken');
let TaskAttachmentService = /*#__PURE__*/(() => {
  class TaskAttachmentService {
    constructor(serviceData, http, taskService, hostService) {
      this.serviceData = serviceData;
      this.http = http;
      this.taskService = taskService;
      this.hostService = hostService;
      serviceData.pipe(filter(data => !!data.partnerId), take(1)).subscribe(data => {
        this.partnerId = data.partnerId;
      });
    }
    uploadFile(file) {
      if (!this.isFileValid(file)) {
        return throwError('Invalid file type or size');
      }
      return this.generatePutUrl(file.type, file.name).pipe(switchMap(generatePutResponse => {
        return this.http.post(this.hostService.hostWithScheme + '/task-attachment/upload', file, {
          headers: {
            'Content-Type': file.type
          },
          observe: 'body',
          responseType: 'blob',
          withCredentials: true,
          params: {
            putUrl: generatePutResponse.generatedUrl,
            partnerId: this.partnerId
          }
        }).pipe(map(() => {
          return {
            name: file.name,
            url: generatePutResponse.shareableUrl
          };
        }));
      }));
    }
    getArmHost() {
      switch (environment) {
        case 'demo':
          return 'https://arm-demo.appspot.com/';
        case 'prod':
        case 'production':
          return 'https://task-manager.biz/';
        default:
          return 'https://arm-demo.appspot.com/';
      }
    }
    isFileValid(file) {
      if (file.size > MAX_FILE_SIZE) {
        return false;
      }
      const group = file.type.split('/')[0];
      return group === 'image' || group === 'video' || SUPPORTED_DOC_FILE_TYPES.includes(file.type);
    }
    getSecretFromURL(url) {
      // URL is formatted as https://[host]/[partnerId]/tasks/attachment/[sharedSecret]/[fileName]
      return url.split('/')[6];
    }
    getFileNameFromURL(url) {
      // URL is formatted as https://[host]/[partnerId]/tasks/attachment/[sharedSecret]/[fileName]
      return url.split('/')[7];
    }
    addAttachment(identity, attachment) {
      return this.taskService.addAttachment(identity.namespace, identity.parentPath, identity.taskId, attachment);
    }
    removeAttachment(identity, attachment) {
      return forkJoin([this.taskService.removeAttachment(identity.namespace, identity.parentPath, identity.taskId, attachment), this.generateDeleteUrl(this.getSecretFromURL(attachment.url)).pipe(switchMap(attachmentAccessResponse => {
        return this.http.delete(attachmentAccessResponse.generatedUrl);
      }))]).pipe(retry(1), map(([version, _]) => {
        return version;
      }));
    }
    generatePutUrl(type, name) {
      const host = this.getArmHost() + 'internalApi/v3/storage/generate/put-url/';
      const body = {
        partnerId: this.partnerId,
        contentType: type,
        fileName: name
      };
      return this.http.post(host, body, {
        withCredentials: true
      }).pipe(map(response => response.data));
    }
    generateGetUrl(secret) {
      return this.generateAccessUrl('get', secret);
    }
    generateDeleteUrl(secret) {
      return this.generateAccessUrl('delete', secret);
    }
    generateAccessUrl(method, secret) {
      const host = this.getArmHost() + 'internalApi/v3/storage/generate/' + method + '-url/';
      const body = {
        partnerId: this.partnerId,
        sharedSecret: secret
      };
      return this.http.post(host, body, {
        withCredentials: true
      }).pipe(map(response => response.data));
    }
  }
  TaskAttachmentService.ɵfac = function TaskAttachmentService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TaskAttachmentService)(i0.ɵɵinject(AttachmentServiceDataInterfaceToken), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(TaskSdkService), i0.ɵɵinject(HostService));
  };
  TaskAttachmentService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TaskAttachmentService,
    factory: TaskAttachmentService.ɵfac,
    providedIn: 'root'
  });
  return TaskAttachmentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccessPermissions, AddAssigneeRequest, AddAttachmentRequest, AddConversationRequest, AddCustomTagsRequest, AddHistoryRequest, AddMultiAssigneeRequest, AddMultipleSubtasksRequest, AddSubtaskRequest, AddTagsRequest, Attachment, AttachmentServiceDataInterfaceToken, CommandResponse, Conversation, CountMetricResponse, DeleteMultiTaskRequest, DeleteTaskRequest, DomainKeyValue, GenerateTaskRequest, GetMetricsFilters, GetMetricsRequest, GetMetricsRequestMetricRequest, GetMetricsResponse, GetTaskRequest, GetTaskResponse, GetTasksRequest, GetTasksResponse, GetTreeRequest, GetTreeResponse, GoType, GroupedMetadata, GroupedTags, History, HostService, KeyValueField, KeyValueTypes, KeyValues, KeyValuesKeyValue, KeyValuesKeyValueValue, Metric, MetricResponses, MetricResponsesMetricResponse, MultiCommandRequest, MultiCommandRequestEvent, MultiCommandResponses, MultiCommandResponsesMultiCommandResponse, MultiSearchTaskRequest, Persona, PersonaType, RangeField, RemoveAssigneeRequest, RemoveAttachmentRequest, RemoveCustomTagsRequest, RemoveMultiAssigneeRequest, RemoveTagsRequest, ReorderSubtaskRequest, RestoreMultiTaskRequest, RestoreTaskRequest, SearchTaskRequest, SearchTaskResponse, SetDescriptionRequest, SetDueDateRequest, SetKeyValue, SetKeyValuesRequest, SetMultiDueDateRequest, SetMultiNotesRequest, SetMultiStatusRequest, SetNotesRequest, SetStatusRequest, SetTitleRequest, SetTypeRequest, Sort, SortDirection, Status, TagGroup, Task, TaskAttachmentService, TaskCommandApiService, TaskIdentity, TaskQueryApiService, TaskSdkService, TaskTree, ValueMetricResponse, buildNamespace, buildParentPath, newGuid };
